import gql from 'graphql-tag';

export default gql`
  mutation ScanLabel($images: [Upload!]!, $userComment: String) {
    dailyTracker {
      scanLabel(images: $images, userComment: $userComment) {
        __typename
        ... on AnalyzedDailyTrackerIngredients {
          primaryIngredient {
            productId
            name
            brand
            baseAmount
            baseUnit
            calories
            proteinGrams
            carbsGrams
            fatGrams
            fiberGrams
            servingQuantity
            servingUnit
            measures {
              measureId
              unit
              amount {
                value
                unit
              }
            }
          }
          hasAlternates
          requestId
        }
        ... on NotFoodError {
          message
          description
        }
        ... on ProductNotFoundError {
          message
          description
        }
        ... on AiAccessDenied {
          accessDeniedMessage: message
          accessDeniedDescription: description
        }
        ... on RateLimitExceeded {
          rateLimitExceededMessage: message
          rateLimitExceededDescription: description
        }
        ... on ValidationException {
          validationCode: code
          messages
          details {
            fieldName
            messages
          }
        }
        ... on Error {
          errorCode: code
          name
          description
        }
      }
    }
  }
`;
